<template>
  <div ref="Dashboardpdf" id="Dashboardpdf">
    <section class="dashboard">
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
        ></loading> -->
      </div>

      <b-card class="mainCardBG" v-if="showDash == true">
        <b-row>
          <b-col md="2">
            <h4 class="page-title mb-1">DASHBOARD</h4>
          </b-col>
          <b-col md="2"> 
            <b-button size="sm" variant="info" @click="goToClientDashboard"
                >Client TEUS Dashboard</b-button
              >
          </b-col>
          <b-col md="3">
            <date-range-picker
              class="mb-1"
              :opens="openLeft"
              :always-show-calendars="showCal"
              v-model="dateRange"
              :startDate="startDate"
              :endDate="endDate"
              :locale-data="locale"
              @update="getData"
            ></date-range-picker>
          </b-col>
          <b-col md="2">
            <model-list-select
              :list="branchList"
              class="mb-1"
              id="branchfilter"
              v-model="branchfilter"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="All"
              @input="getData"
              :isDisabled="
                $sessionsStorage.get('designation') != 'Admin' &&
                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                  ? true
                  : false
              "
            ></model-list-select>
          </b-col>
          <b-col md="2">
            <model-list-select
              class="mb-1"
              :list="clientMaster"
              id="clientNamenew"
              v-model="clientIdFilter"
              option-value="clientId"
              option-text="clientName"
              placeholder="All"
              @input="getData"
            ></model-list-select>
          </b-col>
          <div class="col-md-3 text-right">
            <b-button-group size="sm" class="ml-1">
              <!-- <b-button variant="outline-info" @click="AnalysisReports">Analysis</b-button> -->
              <b-button
                class="ml-1"
                variant="outline-info"
                @click="dashboardReports"
                >Reporting</b-button
              >

              <!-- <b-button class="ml-1" variant="outline-info" @click="openAssignmentPendency"
                >Assignment Pendency</b-button
              > -->
            </b-button-group>
            <b-button class="ml-1" variant="outline-info" @click="getPDF">
              <i class="fa fa-cloud-download" aria-hidden="true"></i>
            </b-button>
            <b-button class="ml-1" variant="outline-info" @click="goEveryDaySale">
              Day Wise Sale
            </b-button>
            <b-button class="ml-1" variant="outline-info" @click="goEveryDayExpense">
              Day Wise Exp
            </b-button>
          </div>
        </b-row>
        <hr />
        <div class="gutr mt-3">
          <div class="row">
            <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">Total Executions</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ totalExec }}
                        </h4>
                        <p style="margin: 0px" class="text-muted mt-3">
                          Export {{ totalExport }}
                        </p>
                        <p class="text-muted">Import {{ totalImport }}</p>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">person_add</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">Sea Shipments</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ totalSeaShipment }}
                        </h4>
                        <p style="margin: 0px" class="text-muted mt-3">
                          Export {{ seaShipmentExport }}
                        </p>
                        <p class="text-muted">Import {{ seaShipmentImport }}</p>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">directions_boat</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">Air Shipments</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ totalAirShipment }}
                        </h4>
                        <p style="margin: 0px" class="text-muted mt-3">
                          Export {{ airShipmentExport }}
                        </p>
                        <p class="text-muted">Import {{ airShipmentImport }}</p>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">flight</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">Container Shipped</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ totalContainerShiped }}
                        </h4>
                        <p style="margin: 0px" class="text-muted mt-3">
                          Export {{ containerShipedExport }}
                        </p>
                        <p class="text-muted">
                          Import {{ containerShipedImport }}
                        </p>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">import_export</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row gutr">
          <div
            v-if="totalExec != '0'"
            class="col-md-6 grid-margin stretch-card"
          >
            <b-card class="formCardDash topFiveHeight">
              <b-card-text>
                <div>
                  <h5 class="card-title mt-3">Executions By Modules</h5>
                  <div class="fluid-container"></div>
                </div>
                <div id="chart">
                  <apexchart
                    v-if="showgraphsAir == true"
                    type="pie"
                    class="mt-3"
                    width="430"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </b-card-text>
            </b-card>
          </div>
          <div class="col-md-6 grid-margin stretch-card">
            <div class="card card-statistics formCardDash">
              <div class="card-body">
                <div class="d-flex justify-content-between flex-wrap">
                  <div>
                    <h5 class="card-title">Enquiry</h5>
                    <div class="fluid-container">
                      <h4 class="card-title font-weight-bold mb-0">
                        {{ totalEnq }}
                      </h4>
                      <p style="margin: 0px" class="text-muted mt-3">
                        Existing Client {{ totalEnqExistClient }}
                      </p>
                      <p class="text-muted">Leads {{ totalEnqLead }}</p>
                    </div>
                  </div>
                  <div>
                    <md-icon class="md-size-1x">add_ic_call</md-icon>
                  </div>
                </div>
              </div>
            </div>
            <div class="gutr">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h5 class="card-title">New Clients</h5>
                      <div class="fluid-container">
                        <h4 class="card-title font-weight-bold mb-0">
                          {{ newClientAdded }}
                        </h4>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">person_add</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr">
          <div class="col-md-6 grid-margin stretch-card">
            <div class="card card-statistics formCardDash">
              <div class="card-body">
                <div class="d-flex justify-content-between flex-wrap">
                  <div>
                    <b-row>
                      <b-col md="6"
                        ><h5 class="card-title">Total Revenue</h5></b-col
                      >
                      <b-col md="6">
                        <model-list-select
                          :list="CustomTypeList"
                          v-model="typeFilter"
                          class="mb-1"
                          option-value="DVal"
                          option-text="DText"
                          placeholder="Select"
                          @input="getData()"
                        ></model-list-select>
                      </b-col>
                    </b-row>
                    <div class="fluid-container">
                      (<span>Sales && Expense</span>)
                      <h4 class="card-title font-weight-bold mb-0">
                        <h4 style="color: blue">
                          INV &#8377; {{ totalTallyAddedRevenueSum }}
                        </h4>
                        <br />
                        <h4 style="color: red">
                          EXP &#8377; {{ totalTallyAddedRevenueSumExp }}
                        </h4>
                        <br />
                        <h4 style="color: #ff6a00">
                          NET &#8377; {{ totalTallyAddedRevenueSumNET }}
                        </h4>
                        <br />

                        <!-- <h4 style="color: blue">
                          DN &#8377; {{ totalTallyAddedRevenueSumDBN }}
                        </h4> -->
                      </h4>
                    </div>
                  </div>
                  <div>
                    <md-icon class="md-size-1x pull-right"
                      >account_balance</md-icon
                    >
                  </div>
                </div>
                <!-- <div class="d-flex justify-content-between flex-wrap">
                  <div>
                    <h5 class="card-title">Total Revenue</h5>

                    <div class="fluid-container">
                      (<span>DR Includes DN</span>)
                      <h4 class="card-title font-weight-bold mb-0">
                       
                        <h4 style="color: blue">
                          DR &#8377; {{ totalTallyAddedRevenueSum }}
                        </h4>
                        <br />
                        <h4>CR &#8377; {{ totalTallyAddedRevenueSumCRN }}</h4>
                        <br />
                        <h4 style="color: #ff6a00">
                          NET &#8377; {{ totalTallyAddedRevenueSumNET }}
                        </h4>
                        <br />
                        
                         <h4 style="color: blue">
                          DN &#8377; {{ totalTallyAddedRevenueSumDBN }}
                        </h4>
                      </h4>
                    </div>
                  </div>
                  <div>
                    <md-icon class="md-size-1x pull-right">account_balance</md-icon>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <div
            v-if="chartOptionsClientReven.length > 0"
            class="col-xl-8 col-sm-6 grid-margin stretch-card"
          >
            <div class="card card-statistics formCardDash">
              <div class="card-body">
                <h5 class="card-title">Revenue By Clients</h5>

                <p class="card-description text-muted">Top 10</p>
                <div id="chart">
                  <apexchart
                    style="margin-top: -20px; margin-left: -25px"
                    v-if="showgraphsRev == true"
                    type="bar"
                    height="340"
                    :options="chartOptionsClientReven"
                    :series="seriesClientRev"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            v-if="chartOptionsConBar.length > 0"
            class="col-md-7 grid-margin stretch-card"
          >
            <div class="card formCardDash">
              <div class="card-body">
                <h4 class="card-title">Container Type</h4>
                <div id="chart">
                  <apexchart
                    style="margin-top: -20px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="300"
                    :options="chartOptionsConBar"
                    :series="seriesConBar"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="chartOptionsShipBar.length > 0"
            class="col-md-5 grid-margin stretch-card"
          >
            <div class="card formCardDash">
              <div class="card-body">
                <h4 class="card-title">Shipping Line</h4>
                <p class="card-description text-muted">
                  Top 5 with No.of container Shipped
                </p>
                <div id="chart">
                  <apexchart
                    style="margin-top: -20px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="300"
                    :options="chartOptionsShipBar"
                    :series="seriesShipBar"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            v-if="topDestinationExportData.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card formCardDash">
              <div class="card-body">
                <h4 class="card-title">Export Destination</h4>
                <p class="card-description text-muted">
                  Top 5 with No.of container Shipped
                </p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <tbody>
                      <tr
                        v-for="(item4, index) in topDestinationExportData"
                        :key="index"
                      >
                        <td class="pl-0">{{ item4.exportDestinationName }}</td>
                        <td class="pr-0 text-right">
                          <b-badge pill variant="primary">
                            {{ item4.sumOfContainerExportDestination }}
                          </b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="topDestinationImportData.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card formCardDash topFiveHeight">
              <div class="card-body">
                <h4 class="card-title">Import Destination</h4>
                <p class="card-description text-muted">
                  Top 5 with No.of container Shipped
                </p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <tbody>
                      <tr
                        v-for="(item5, index) in topDestinationImportData"
                        :key="index"
                      >
                        <td class="pl-0">{{ item5.importDestiName }}</td>
                        <td class="pr-0 text-right">
                          <b-badge pill variant="primary">
                            {{ item5.sumOfContainerImportDestination }}
                          </b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="topLoadPortData.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card formCardDash topFiveHeight">
              <div class="card-body">
                <h4 class="card-title">Port of Loading Export</h4>
                <p class="card-description text-muted">
                  Loading Ports with No.of container Shipped
                </p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <tbody>
                      <tr
                        v-for="(item6, index) in topLoadPortData"
                        :key="index"
                      >
                        <td class="pl-0">{{ item6.topLoadPort }}</td>
                        <td class="pr-0 text-right">
                          <b-badge pill variant="primary">
                            {{ item6.sumOfContainerLoadPort }}
                          </b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr">
          <div
            v-if="topCommodityExportData.length > 0"
            class="col-md-6 grid-margin stretch-card"
          >
            <div class="card formCardDash">
              <div class="card-body">
                <h4 class="card-title">Most Exported Commodity</h4>
                <p class="card-description text-muted">Top 5 (Sea)</p>
                <div class="template-demo">
                  <table class="table mb-0">
                    <tbody>
                      <tr
                        v-for="(item3, index) in topCommodityExportData"
                        :key="index"
                      >
                        <td class="pl-0">{{ item3.itemDescription }}</td>
                        <td class="pr-0 text-right">
                          <b-badge variant="primary">
                            {{ item3.commodityCount }}
                          </b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="chartOptionsExCom.length > 0"
            class="col-md-6 grid-margin stretch-card"
          >
            <div style="height: 340px" class="card formCardDash">
              <div class="card-body">
                <h4 class="card-title">Most Exported Commodity</h4>
                <p class="card-description text-muted">Top 5 (Sea)</p>
                <div id="chart">
                  <apexchart
                    style="margin-top: -20px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="300"
                    :options="chartOptionsExCom"
                    :series="seriesExCom"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr">
          <div
            v-if="chartOptionstopAirline.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card formCardDash">
              <div class="card-body">
                <h5 class="card-title">Top 10 Airlines Used</h5>
                <p class="card-description text-muted">Export</p>
                <div id="chart">
                  <apexchart
                    style="margin-top: -30px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="240"
                    :options="chartOptionstopAirline"
                    :series="seriestopAirline"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="chartOptionsDeparture.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card formCardDash">
              <div class="card-body">
                <h4 class="card-title">Top Departure Airports Export</h4>
                <p class="card-description text-muted">
                  Top 10 with No.of Packages (Air)
                </p>

                <div id="chart55">
                  <apexchart
                    style="margin-top: -30px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="240"
                    :options="chartOptionsDeparture"
                    :series="seriesDeparture"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="chartOptionsArrive.length > 0"
            class="col-md-4 grid-margin stretch-card"
          >
            <div class="card formCardDash">
              <div class="card-body">
                <h4 class="card-title">Top Destination Airports Export</h4>
                <p class="card-description text-muted">
                  Top 10 By No.of Packages (Air)
                </p>
                <div id="chart22">
                  <apexchart
                    style="margin-top: -30px; margin-left: -25px"
                    v-if="showgraphsAir == true"
                    type="bar"
                    height="240"
                    :options="chartOptionsArrive"
                    :series="seriesArrive"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr"></div>
      </b-card>
      <b-card v-else class="mainCardBG">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-brand v-if="showDash == false">
            <h4 class="page-title" v-if="employeeName != ''">
              Welcome
              <small>{{ employeeName }}</small>
            </h4>
          </b-navbar-brand>
        </b-navbar>
      </b-card>
    </section>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
  </div>
</template>

<script>
import { URL_BASE } from "../../../helper/constant.js";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../../helper/collection";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  beforeMount() {
    if (this.$sessionsStorage.get("is_Mobile") == "yes") {
      this.$router.push({
        path: "/lead/leadlist",
      });
    } else if (
      this.$sessionsStorage.get("is_Mobile") == "port" &&
      this.$sessionsStorage.get("portLoginAccess") == 1
    ) {
      this.$router.push({
        path: "/viewAllModuleDetails/viewAllModuleDetails",
      });
    }
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    DateRangePicker,
    ModelListSelect,
  },
  computed: {},
  data() {
    return {
      CustomTypeList: [
        {
          DVal: "Assignment",
          DText: "Assignment",
        },
        {
          DVal: "Voucher",
          DText: "Voucher",
        },
      ],
      typeFilter: "Voucher",
      branchList: [],
      branchfilter: "",
      clientMaster: [],
      clientIdFilter: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openLeft: "left",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showgraphsAir: false,
      showgraphsRev: false,
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      employeeName: "",
      employeeLoc: "",
      cunvertUSD: "75",
      calculatGraphRevenue: "75",
      totalEnq: "",
      totalEnqExistClient: "",
      totalEnqLead: "",
      totalExec: "",
      totalExport: "",
      totalImport: "",
      totalSeaShipment: "",
      seaShipmentExport: "",
      seaShipmentImport: "",
      totalAirShipment: "",
      airShipmentExport: "",
      airShipmentImport: "",
      newClientAdded: "",
      totalContainerShiped: "",
      containerShipedExport: "",
      containerShipedImport: "",
      FFfinalAmountUSD: "",
      FFfinalAmountINR: "",
      FFfinalAmountEURO: "",
      FFfinalAmountAED: "",
      FFfinalAmountGBP: "",
      FFfinalAmountZAR: "",
      FFfinalAmountCAD: "",
      FFfinalAmountJOD: "",

      CustomRevenue: "",
      TPTRevenue: "",
      totalTallyAddedRevenueSum: 0,
      totalTallyAddedRevenueSumExp: 0,
      // totalTallyAddedRevenueSumCRN: "",
      // totalTallyAddedRevenueSumDBN: "",
      totalTallyAddedRevenueSumNET: "",
      finalAmountINR: "",
      finalAmountUSD: "",
      finalAmountAED: "",
      finalAmountEURO: "",
      finalAmountGBP: "",
      finalAmountZAR: "",
      finalAmountCAD: "",
      finalAmountJOD: "",
      AEDRates: 20.42,
      JODRates: 105.75,
      CADRates: 55.21,
      ZARRates: 4.48,
      GBPRates: 94.16,
      EURORates: 85.62,
      USDRates: 74.98,
      backendAmountUSD: "",
      topSlineData: [],
      topContainerData: [],
      topAirlineData: [],
      topCommodityExportData: [],
      topDepartAirPortData: [],
      topArivalAirPortData: [],
      topDestinationExportData: [],
      topDestinationImportData: [],
      topLoadPortData: [],

      isLoading: false,
      series: [],
      chartOptions: {
        plotOptions: {
          pie: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          width: 200,
          type: "pie",
        },
        labels: [],

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      seriestopAirline: [
        {
          data: [],
        },
      ],
      chartOptionstopAirline: {
        chart: {
          type: "bar",
          height: 380,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: ["#33b2df", "#d4526e"],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },

        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return "";
              },
            },
          },
        },
      },
      seriesClientRev: [
        {
          name: "Ammount",
          data: [],
        },
      ],
      chartOptionsClientReven: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -30,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Ammount (INR)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      seriesDeparture: [
        {
          data: [],
        },
      ],
      chartOptionsDeparture: {
        chart: {
          type: "bar",
          height: 380,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: [
          "#33b2df",
          "#546E7A",
          "#d4526e",
          "#13d8aa",
          "#A5978B",
          "#2b908f",
          "#f9a3a4",
          "#90ee7e",
          "#f48024",
          "#69d2e7",
        ],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },

        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return "";
              },
            },
          },
        },
      },
      seriesArrive: [
        {
          data: [],
        },
      ],
      chartOptionsArrive: {
        chart: {
          type: "bar",
          height: 380,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: [
          "#33b2df",
          "#546E7A",
          "#d4526e",
          "#13d8aa",
          "#A5978B",
          "#2b908f",
          "#f9a3a4",
          "#90ee7e",
          "#f48024",
          "#69d2e7",
        ],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },

        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function () {
                return "";
              },
            },
          },
        },
      },

      seriesConBar: [
        {
          name: "Export ",
          data: [],
        },
        {
          name: "Import",
          data: [],
        },
      ],

      chartOptionsConBar: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: [],
        },
        legend: {
          position: "bottom",
          offsetY: 10,
        },
        fill: {
          opacity: 1,
        },
      },
      seriesExCom: [
        {
          name: "No.of Times Used",
          data: [],
        },
      ],
      chartOptionsExCom: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "off",
        },
        yaxis: {
          title: {
            text: "No. of Times Used",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      seriesShipBar: [
        {
          name: "No.of Container Shiped",
          data: [],
        },
      ],
      chartOptionsShipBar: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "No. of Container Shipped",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    };
  },
  methods: {
    goToClientDashboard() {
      this.$router.push({
        path: "/dashboard/client-teus-dashboard",
      });
    },
    gotToFullClientReports() {
      this.$router.push({
        path: "/dashboard/clientProfile",
      });
    },
    changeNumberFormat(num) {
      if (num > 9999999) {
        return Math.abs(num) > 9999999
          ? Math.sign(num) * (Math.abs(num) / 10000000).toFixed(2) + " Crore"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 99999) {
        return Math.abs(num) > 99999
          ? Math.sign(num) * (Math.abs(num) / 100000).toFixed(2) + " Lakhs"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 999) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + " Thousand"
          : Math.sign(num) * Math.abs(num);
      } else {
        return num;
      }
    },

    convertCurrency(ID) {
      if (ID == "USD") {
        this.finalAmountUSD =
          parseInt(this.backendAmountUSD) * parseInt(this.cunvertUSD) + " INR";
      }
      if (this.cunvertUSD == "") {
        this.finalAmountUSD = this.backendAmountUSD;
      }
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },

    getData() {
      this.isLoading = true;
      this.showgraphsRev = false;
      this.showDash = false;
      this.chartOptionsClientReven.xaxis.categories = [];
      this.chartOptions.labels = [];
      this.topCommodityExportData = [];
      this.series = [];
      this.seriesClientRev[0].data = [];
      this.chartOptionsShipBar.xaxis.categories = [];
      this.seriesShipBar[0].data = [];
      this.clientMaster = [];
      this.branchList = [];

      let type_Size = {
        DASH: "DASH",
        dateRange: this.dateRange,

        clientIdFilter: this.clientIdFilter,
        branchfilter: this.branchfilter,
        typeFilter: this.typeFilter,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/dashboardData_VP1.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            } else {
              // console.log(data);
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.branchList.length > 0) {
                this.branchList = data.branchList;
              }
              if (data.topDestinationExportData.length > 0) {
                this.topDestinationExportData = data.topDestinationExportData;
              }
              if (data.topDestinationImportData.length > 0) {
                this.topDestinationImportData = data.topDestinationImportData;
              }
              if (data.topLoadPortData.length > 0) {
                this.topLoadPortData = data.topLoadPortData;
              }
              if (data.topSlineName.length > 0) {
                this.chartOptionsShipBar.xaxis.categories = data.topSlineName;
                this.seriesShipBar[0].data = data.topSlineConCount;
              }
              if (data.topCommodityExportData.length > 0) {
                this.topCommodityExportData = data.topCommodityExportData;
                this.chartOptionsExCom.xaxis.categories = data.commodityExport;
                this.seriesExCom[0].data = data.commodityCount;
              }
              if (data.topAirlineName.length > 0) {
                this.chartOptionstopAirline.xaxis.categories =
                  data.topAirlineName;
                this.seriestopAirline[0].data = data.topAirlineCount;
              }

              if (data.topDepartPort.length > 0) {
                this.chartOptionsDeparture.xaxis.categories =
                  data.topDepartPort;

                this.seriesDeparture[0].data = data.topDepartPortPkg;
              }
              if (data.topExDestiPort.length > 0) {
                this.chartOptionsArrive.xaxis.categories = data.topExDestiPort;
                this.seriesArrive[0].data = data.totalPakDestiAir;
              }

              if (data.userDetails.length > 0) {
                if (data.userDetails[0].dashBoardPermission == "Yes") {
                  this.showDash = true;
                } else {
                  this.showDash = false;
                  if (data.userDetails[0].type == "1") {
                    this.employeeName =
                      data.userDetails[0].employeeName.toUpperCase();
                    this.employeeLoc =
                      data.userDetails[0].employeeLoc.toUpperCase();
                  }
                }
              }

              this.totalEnq = data.totalEnq;
              this.totalEnqExistClient = data.totalEnqExistClient;
              this.totalEnqLead = data.totalEnqLead;
              this.totalExec = data.totalExec;
              this.totalExport = data.totalExport;
              this.totalImport = data.totalImport;
              this.totalSeaShipment = data.totalSeaShipment;
              this.seaShipmentExport = data.seaShipmentExport;
              this.seaShipmentImport = data.seaShipmentImport;
              this.totalAirShipment = data.totalAirShipment;
              this.airShipmentExport = data.airShipmentExport;
              this.airShipmentImport = data.airShipmentImport;
              this.newClientAdded = data.newClientAdded;
              this.totalContainerShiped = data.totalContainerShiped;
              this.containerShipedExport = data.containerShipedExport;
              this.containerShipedImport = data.containerShipedImport;
              // this.totalTallyAddedRevenueSum = this.changeNumberFormat(parseFloat( data.totalTallyAddedRevenueSum)) ;
              this.totalTallyAddedRevenueSum =
                this.changeNumberFormat(
                  parseFloat(data.totalTallyAddedRevenueSum)
                ) +
                " + ₹" +
                this.changeNumberFormat(parseFloat(data.total_GstVal)) +
                " = ₹" +
                this.changeNumberFormat(
                  parseFloat(data.total_GstRevenueSumVal)
                );

              this.totalTallyAddedRevenueSumExp =
                this.changeNumberFormat(
                  parseFloat(data.totalTallyAddedRevenueSumExp)
                ) +
                " + ₹" +
                this.changeNumberFormat(parseFloat(data.total_GstValExp)) +
                " = ₹" +
                this.changeNumberFormat(
                  parseFloat(data.total_GstRevenueSumValExp)
                );

              // this.totalTallyAddedRevenueSumCRN =
              //   this.changeNumberFormat(parseFloat(data.totalTallyAddedRevenueSumCRN)) +
              //   " + ₹" +
              //   this.changeNumberFormat(parseFloat(data.total_GstValCRN)) +
              //   " = ₹" +
              //   this.changeNumberFormat(parseFloat(data.total_GstRevenueSumValCRN));

              // this.totalTallyAddedRevenueSumDBN =
              //   this.changeNumberFormat(parseFloat(data.totalTallyAddedRevenueSumDBN)) +
              //   " + ₹" +
              //   this.changeNumberFormat(parseFloat(data.total_GstValDBN)) +
              //   " = ₹" +
              //   this.changeNumberFormat(parseFloat(data.total_GstRevenueSumValDBN));

              // this.totalTallyAddedRevenueSumNET =
              //   this.changeNumberFormat(
              //     parseFloat(data.netTotalVal)
              //   ) +
              //   " + ₹" +
              //   this.changeNumberFormat(
              //     parseFloat(data.netTotalGSTVal)
              //   ) +
              //   " = ₹" +
              //   this.changeNumberFormat(
              //     parseFloat(data.netTotalGSTSumVal)
              //   );

              this.totalTallyAddedRevenueSumNET =
                this.changeNumberFormat(
                  parseFloat(
                    data.totalTallyAddedRevenueSum -
                      data.totalTallyAddedRevenueSumExp
                  )
                ) +
                " + ₹" +
                this.changeNumberFormat(
                  parseFloat(data.total_GstVal - data.total_GstValExp)
                ) +
                " = ₹" +
                this.changeNumberFormat(
                  parseFloat(
                    data.total_GstRevenueSumVal - data.total_GstRevenueSumValExp
                  )
                );

              // top Container Type chart
              if (data.containerMasterData.length > 0) {
                let conArry = [];
                let conArryIm = [];
                let conTpeArry = [];
                for (let m = 0; m < data.containerMasterData.length; m++) {
                  conTpeArry.push(data.containerMasterData[m].containerType);
                  let conSum = data.topContainerDataEx.filter((x) => {
                    return (
                      x.multipleContainerType ==
                      data.containerMasterData[m].containerType
                    );
                  });
                  if (conSum.length > 0) {
                    const ages = conSum.reduce(
                      (a, { multipleContainerType, multiConNo }) => (
                        (a[multipleContainerType] =
                          (a[multipleContainerType] || 0) + +multiConNo),
                        a
                      ),
                      {}
                    );
                    let abc = Object.values(ages);
                    let pq = abc.toString();
                    conArry.push(parseInt(pq));
                  } else {
                    let noCon = data.containerMasterData[m].containerType;
                    const ages = data.containerMasterData.reduce(
                      (a, { noCon, isContainerTypeActive }) => (
                        (a[noCon] = (a[noCon] || 0) + +0), a
                      ),
                      {}
                    );
                    let abc = Object.values(ages);
                    let pq = abc.toString();
                    conArry.push(parseInt(pq));
                  }

                  let conSumIm = data.topContainerDataIm.filter((x) => {
                    return (
                      x.multipleContainerType ==
                      data.containerMasterData[m].containerType
                    );
                  });
                  if (conSumIm.length > 0) {
                    const agesIm = conSumIm.reduce(
                      (a, { multipleContainerType, multiConNo }) => (
                        (a[multipleContainerType] =
                          (a[multipleContainerType] || 0) + +multiConNo),
                        a
                      ),
                      {}
                    );
                    let abc1 = Object.values(agesIm);
                    let pq1 = abc1.toString();
                    conArryIm.push(parseInt(pq1));
                  } else {
                    let noCon1 = data.containerMasterData[m].containerType;
                    const ages1 = data.containerMasterData.reduce(
                      (a, { noCon1, isContainerTypeActive }) => (
                        (a[noCon1] = (a[noCon1] || 0) + +0), a
                      ),
                      {}
                    );
                    let abc1 = Object.values(ages1);
                    let pq1 = abc1.toString();
                    conArryIm.push(parseInt(pq1));
                  }
                }
                this.chartOptionsConBar.xaxis.categories = conTpeArry;
                this.seriesConBar[0].data = conArry;
                this.seriesConBar[1].data = conArryIm;
              }

              this.series = data.TotalExecutionChartData;
              for (
                let q = 0;
                q < data.TotalExecutionChartLabelData.length;
                q++
              ) {
                this.chartOptions.labels.push(
                  data.TotalExecutionChartLabelData[q]
                );
              }

              this.showgraphsAir = true;
              this.showgraphsRev = true;

              this.isLoading = false;
            }
          }
        })
        .catch((error) => {});
    },
    goEveryDaySale(){
      this.$router.push({
        path: "/sale/every-day-sale-dash",
      });
    },
    goEveryDayExpense(){
      this.$router.push({
        path: "/exp/every-day-exp-dash",
      });
    },
    dashboardReports() {
      this.$router.push({
        path: "/dashboard/dashboardReports",
      });
    },
    // openAssignmentPendency() {
    //   this.$router.push({
    //     path: "/dashboard/assignmentPendency",
    //   });
    // },
    AnalysisReports() {
      this.$router.push({
        path: "/dashboard/analysisDashboard",
      });
    },
    randomValue() {
      this.value = Math.random() * this.max;
    },

    // Added By Priyanshu Singh Start
    download() {
      let windowHeight = window.outerHeight;
      let windowWidth = window.outerWidth;
      let pdf = new jsPDF();

      let canvasElement = document.createElement("canvas");
      canvasElement.width = 4000;
      canvasElement.height = 4000;

      html2canvas(this.$refs.Dashboardpdf, {
        canvas: canvasElement,
        width: windowWidth,
        height: windowHeight,
      })
        .then((canvas) => {
          const img = canvas.toDataURL("image/jpeg", 5);
          document.body.appendChild(canvas);
          pdf.addImage(img, "JPEG", 10, 10);
          pdf.save("sample.pdf");

          alert("works");
        })
        .catch((err) => {
          alert("error");
        });
    },
    getPDF() {
      var HTML_Width = $("#Dashboardpdf").width();
      var HTML_Height = $("#Dashboardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#Dashboardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        // console.log(canvas.height + "  " + canvas.width);

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }
        var date = new Date();
        var timestamp = date.getTime();
        pdf.save("Main_Dashboard_Document_" + timestamp + ".pdf");
      });
    },

    // Added By Priyanshu Singh End
  },
};
</script>

<style scoped>
.topFiveHeight {
  height: 315px !important;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #ffffff !important;
}
.mainCard {
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 10px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: none !important;
}
.page-header {
  display: flex;
  align-items: center;
  margin: 1.5rem 2rem 1.5rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.topDivCard {
  margin: 1.5rem 2rem 1.5rem;

  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin: 1.5rem 1rem 1.5rem;
  margin-bottom: 0rem !important;
  font-weight: 600 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.col-lg-6 {
  width: 49%;
}
.col-lg-4 {
  width: 32.6%;
}
</style>



// WEBPACK FOOTER //
// dashboard.vue?25ed6cff